import { render, staticRenderFns } from "./Joincms.vue?vue&type=template&id=dbea4f2e"
import script from "./Joincms.vue?vue&type=script&lang=js"
export * from "./Joincms.vue?vue&type=script&lang=js"
import style0 from "./Joincms.vue?vue&type=style&index=0&id=dbea4f2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports